import { render, staticRenderFns } from "./UnregisteredUserPage.vue?vue&type=template&id=2766798b&"
import script from "./UnregisteredUserPage.vue?vue&type=script&lang=js&"
export * from "./UnregisteredUserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports